
if(Object.append){
    Object.append(Element.NativeEvents, {	dragstart: 2, drag: 2, dragend: 2, dragenter: 2, dragover: 2, dragleave: 2, drop: 2 });
}else{
    $extend(Element.NativeEvents, {	dragstart: 2, drag: 2, dragend: 2, dragenter: 2, dragover: 2, dragleave: 2, drop: 2 });
}